const state = {
  user: false,
  platformList: [
    {value: '淘宝', label: '淘宝', iconLabel: '淘宝', icon: 'taobaoicon', color: '#FF4400'},
    {value: '天猫', label: '天猫', iconLabel: '淘宝', icon: 'tianmaoicon', color: '#EA333A'},
    {value: '京东', label: '京东', iconLabel: '京东', icon: 'jingdongicon', color: '#E31D1A'},
    {value: '拼多多', label: '拼多多', iconLabel: '拼多多', icon: 'pinduoduo', color: '#F40009'},
    {value: '微店', label: '微店', iconLabel: '微店', icon: 'wsc', color: '#E31D1A'},
    {value: '有赞', label: '有赞', iconLabel: '有赞', icon: 'wsc', color: '#E31D1A'},
    {value: '京喜', label: '京喜', iconLabel: '京喜', icon: 'jx', color: '#E31D1A'},
    {value: '抖音小店', label: '抖音小店', iconLabel: '抖音', icon: 'dyxd', color: '#333'},
    {value: '阿里巴巴', label: '阿里巴巴', iconLabel: '阿里巴巴', icon: 'alibaba', color: '#FF6600'},
    {value: '快手', label: '快手', iconLabel: '快手', icon: 'ks', color: '#FF4906'},
    {value: '淘宝特价版', label: '淘宝特价版', iconLabel: '淘宝特价版', icon: 'tt', color: '#FF0D40'}
  ],
  addressType: 1,
  addressId: 0,
  activityForm: {
    wx: '',
    wxGroup: '',
    prize: '',
    addressId: '',
    remarks: ''
  }
}

const mutations = {
  setUser (state, value) {
    state.user = value
  },
  setAddressType (state, value) {
    state.addressType = value
  },
  setAddressId (state, value) {
    state.addressId = value
  },
  setActivityForm (state, value) {
    state.activityForm = value
  },
  resetActivityForm (state, value) {
    state.activityForm = {
      wx: '',
      wxGroup: '',
      prize: '',
      addressId: '',
      remarks: ''
    }
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js